import { useContext } from "react";
import {
  WorkoutPlanContext,
  WorkoutPlanContextValue,
} from "./WorkoutPlanProvider";

/** Read the workout plan store. Throws outside `WorkoutPlanProvider`, like `useSubject`. */
export const useWorkoutPlan = (): WorkoutPlanContextValue => {
  const value = useContext(WorkoutPlanContext);
  if (!value) {
    throw new Error("useWorkoutPlan must be used within WorkoutPlanProvider");
  }
  return value;
};

export default useWorkoutPlan;
